export enum RouteNames {
    Home = '/',
    Login = '/login',
    CreateAccount = '/create-account',
    ConfirmEmail = '/confirm-email',
    ForgotPassword = '/forgot-password',
    ForgotPasswordSuccess = '/forgot-password-success',
    ForgotPasswordCode = '/forgot-password-code',
    UserPreferences = '/user-preferences',
    MyProfile = '/profile',
    Info = '/info',
    ManageHabitats = '/habitats/manage',
    Observations = '/observations',
    EditObservations = '/observations/edit',
    ManageUsers = '/users/manage',
    CreateObservations = '/observations/create',
    TermsOfService = '/terms-of-service',
    CreateAccountSuccess = '/success',
    AccountVerification = '/account-verification',
    PrivacyPolicy = '/privacy-policy',
    DeactivateAccount = '/deactivate-account',
    DeactivateAccountSuccess = '/deactivate-account-success'
}
